export const blist = /(?:^|\n+)([-*#]+)/;

const rxUlOl = /^(ul|ol)$/i;
export function listTag(state, p) {
  const ltag = p.blist[0] === '#' ? 'ol' : 'ul';
  const depth = p.blist.length;
  const startLi = len => state.startTag('li', null,
    { type: 'b', deep: len });
  const closeLi = () => state.closeTag('b', 'li');
  const startList = () => state.startTag(ltag, null, { type: 'b', deep: 1 });
  const proximateLi = nonEmpty => {
    const li = state.findIdx('b', 'li');
    const ulol = state.findIdx('b', rxUlOl);
    if (nonEmpty) return li < ulol && li > 0;
    else return li < ulol && li >= 0;
  };

  while (true) {
    const lists = state.findAll('b', rxUlOl);
    if (lists.length === 0) state.closeTag('b'); // new list, close any blocks

    if (lists.length === depth) {
      if (proximateLi(1)) closeLi();
      if (!proximateLi()) startLi(lists.length);
      break;
    } else if (lists.length < depth) {
      startList();
      if (!proximateLi()) startLi(lists.length);
    } else if (lists.length > depth) {
      if (proximateLi()) closeLi();
      state.closeTag(lists[0]);
    }
  }
}
